import { render, staticRenderFns } from "./PaymentBatchesWidget.vue?vue&type=template&id=2fc11790&scoped=true&"
import script from "./PaymentBatchesWidget.vue?vue&type=script&lang=js&"
export * from "./PaymentBatchesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc11790",
  null
  
)

export default component.exports